import {useSelector} from 'react-redux'

export function useCurrentAccountUser() {
  return useSelector(state => state.profile.currentAccountUser || {})
}
